import { InjectionToken } from '@angular/core';

import type {
	CreateUserUseCase,
	DeleteUserUseCase,
	FindAllUsersUseCase,
	GetLoggedUserUseCase,
	ResendActivationCodeUseCase,
	UpdateApiKeyAccessUseCase,
	UpdateLastAlertsCheckUseCase,
	UpdateUserUseCase
} from '@contexts/users/application';

export const FIND_ALL_USERS_USE_CASE = new InjectionToken<FindAllUsersUseCase>(
	'FindAllUsersUseCase'
);

export const CREATE_USER_USE_CASE = new InjectionToken<CreateUserUseCase>('CreateUserUseCase');
export const UPDATE_USER_USE_CASE = new InjectionToken<UpdateUserUseCase>('UpdateUserUseCase');
export const DELETE_USER_USE_CASE = new InjectionToken<DeleteUserUseCase>('DeleteUserUseCase');
export const GET_LOGGED_USER_USE_CASE = new InjectionToken<GetLoggedUserUseCase>(
	'GetLoggedUserUseCase'
);
export const RESEND_ACTIVATION_CODE_USE_CASE = new InjectionToken<ResendActivationCodeUseCase>(
	'ResendActivationCodeUseCase'
);
export const UPDATE_API_KEY_ACCESS_USE_CASE = new InjectionToken<UpdateApiKeyAccessUseCase>(
	'UpdateApiKeyAccessUseCase'
);
export const UPDATE_LAST_ALERTS_CHECK_USE_CASE = new InjectionToken<UpdateLastAlertsCheckUseCase>(
	'UpdateLastAlertsCheckUseCase'
);
